const dateToNumber = (date: string) => {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }

  return Number(date.replace('-', ''));
};

export default dateToNumber;